import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
    selector: 'pen-icon-cell-renderer',
    template: `
        <div class="editable-cell">
            <span>{{ value }}</span>
            <p-icon *ngIf="!isReadOnly" [name]="'pen-edit-2'" (click)="onPenClick($event)"></p-icon>
        </div>
    `,
    styleUrls: ['./pen-icon-cell-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PenIconCellRendererComponent implements ICellRendererAngularComp {
    value = '';
    isReadOnly = false;
    private params!: PenIconCellRendererParams;

    constructor(private readonly cd: ChangeDetectorRef) {}

    agInit(params: PenIconCellRendererParams): void {
        this.params = params;
        this.value = params.value ?? '';
        this.isReadOnly = params.isReadOnlyFn?.() ?? false;
    }

    refresh(params: PenIconCellRendererParams): boolean {
        this.params = params;
        this.value = params.value ?? '';
        this.isReadOnly = params.isReadOnlyFn?.() ?? false;
        this.cd.markForCheck();
        return true;
    }

    onPenClick(event: MouseEvent): void {
        event.stopPropagation();
        this.params.onEditClick(this.params);
    }
}

export interface PenIconCellRendererParams extends ICellRendererParams {
    isReadOnlyFn: () => boolean;
    onEditClick: (params: PenIconCellRendererParams) => void;
}
